import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import useAnimateCss, { useAnimateCssStagger } from "../../hooks/useAnimateCss";
import faqImg from "../../assets/images/misc/steel-rebar-2.webp";

const faqs = [
  { q: "faq-1-q", a: "faq-1-a" },
  { q: "faq-2-q", a: "faq-2-a" },
  { q: "faq-3-q", a: "faq-3-a" },
  { q: "faq-4-q", a: "faq-4-a" },
  { q: "faq-5-q", a: "faq-5-a" },
];

function FaqSection() {
  const { t } = useTranslation();
  const eyebrowRef   = useAnimateCss("animate__fadeInDown", 0,   0.15);
  const headRef      = useAnimateCss("animate__fadeInUp",   120, 0.15);
  const accordionRef = useAnimateCssStagger("animate__fadeInLeft", 90, 0.08);
  const imgRef       = useAnimateCss("animate__zoomIn",     0,   0.15, 700);
  const ctaRef       = useAnimateCss("animate__fadeInUp",   200, 0.15);

  return (
    <section className="faq-section">
      <div className="container">
        {/* Centered header */}
        <div className="faq-header">
          <span className="faq-eyebrow" ref={eyebrowRef as any}>{t("FAQs")}</span>
          <h2 className="faq-main-heading" ref={headRef as any}>{t("faq-heading")}</h2>
        </div>

        <div className="row g-5 align-items-start">
          {/* LEFT — custom accordion */}
          <div className="col-lg-7">
            <div className="faq-accordion" ref={accordionRef as any}>
              {faqs.map((faq, i) => (
                <details
                  key={i}
                  className="faq-item"
                  open={i === 0 ? true : undefined}
                >
                  <summary className="faq-item-summary">
                    <span className="faq-item-question">{t(faq.q)}</span>
                    <span className="faq-item-icon">
                      <svg className="faq-icon-minus" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 15.345h32v2.11h-32v-2.11z" />
                      </svg>
                      <svg className="faq-icon-plus" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                        <path d="M32 15.345h-14.945v-14.945h-2.11v14.945h-14.945v2.11h14.945v14.945h2.11v-14.945h14.945z" />
                      </svg>
                    </span>
                  </summary>
                  <div className="faq-item-body">{t(faq.a)}</div>
                </details>
              ))}
            </div>
          </div>

          {/* RIGHT — image + CTA box */}
          <div
            className="col-lg-5 faq-right-col"
            style={{ paddingLeft: "50px", paddingRight: "50px" }}
          >
            <img
              src={faqImg}
              alt="Al Madina Steel"
              className="faq-side-img"
              ref={imgRef as any}
            />
            <div className="faq-still-box" ref={ctaRef as any}>
              <h4 className="faq-still-heading">{t("faq-still")}</h4>
              <Link to="/about" className="btn-primary-custom">
                {t("Who We Are")} &nbsp;
                <i className="bi bi-arrow-right" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default FaqSection;
